module.exports = __webpack_public_path__ + "img/game-bg.0ed170d.webp";